// Commonly used Rubik's Cube face colors and utility palette

export const COLORS = {
  WHITE: '#ffffff',   // Up
  YELLOW: '#ffd500',  // Down
  ORANGE: '#ff8c00',  // Left
  RED: '#ff0000',     // Right
  GREEN: '#00b050',   // Front
  BLUE: '#0050ff',    // Back
  BLACK: '#111111',   // Internal/None
  // UI/utility
  GRAY: '#888888',
  DARK: '#222222',
  LIGHT: '#f5f5f5',
}

// For Three.js numeric color usage
export const COLORS_HEX = {
  WHITE: 0xffffff,
  YELLOW: 0xffd500,
  ORANGE: 0xff8c00,
  RED: 0xff0000,
  GREEN: 0x00b050,
  BLUE: 0x0050ff,
  BLACK: 0x111111,
  GRAY: 0x888888,
  DARK: 0x222222,
  LIGHT: 0xf5f5f5,
}
